const capitalizeFirstLetter = (text?: string): string => {
  if (text) {
    return text[0].toUpperCase() + text.slice(1);
  }
  return "";
};

const produceInitials = (text?: string): string => {
  const initials = text
    ?.match(/(^\S\S?|\s\S)?/g)
    ?.map((v) => v.trim())
    ?.join("")
    ?.match(/(^\S|\S$)?/g)
    ?.join("")
    ?.toLocaleUpperCase();

  return initials || "";
};

export const StringUtils = {
  capitalizeFirstLetter,
  produceInitials,
};
